import { createClient, everything } from "./generated";
import { fetch } from "../utils";
var getCrud = function (name) {
    return ({
        findUnique: "findUnique".concat(name),
        findFirst: "findFirst".concat(name),
        findMany: "findMany".concat(name),
        groupBy: "groupBy".concat(name),
        aggregate: "aggregate".concat(name),
        createOne: "createOne".concat(name),
        createMany: "createMany".concat(name),
        updateOne: "updateOne".concat(name),
        updateMany: "updateMany".concat(name),
        deleteOne: "deleteOne".concat(name),
        deleteMany: "deleteMany".concat(name),
        upsertOne: "upsertOne".concat(name),
        list: "list".concat(name),
        one: "one".concat(name),
        actions: "actions".concat(name),
        create: "create".concat(name),
        update: "update".concat(name),
        import: "import".concat(name),
        lc: function (action) { return "".concat(action).concat(name); },
    });
};
export var client = createClient({
    fetcher: function (data) {
        var replacer = function (key, value) {
            if (value instanceof File) {
                return null; // заменяет объекты File на null
            }
            return value;
        };
        var operations = JSON.stringify(data, replacer);
        var map = {};
        var files = [];
        var fileKeys = [];
        var fileIndex = 0;
        var handleFile = function (file, path) {
            if (file instanceof File) {
                var fileKey = "".concat(fileIndex);
                files.push(file);
                fileKeys.push(fileKey);
                map[fileKey] = [path];
                fileIndex += 1;
            }
        };
        var _loop_1 = function (variableKey) {
            var variable = data.variables[variableKey];
            if (Array.isArray(variable)) {
                variable.forEach(function (file, index) {
                    handleFile(file, "variables.".concat(variableKey, ".").concat(index));
                });
            }
            else if (typeof variable === "object" && !(variable instanceof File)) {
                var _loop_2 = function (innerKey) {
                    var innerVariable = variable[innerKey];
                    if (Array.isArray(innerVariable)) {
                        innerVariable.forEach(function (file, index) {
                            handleFile(file, "variables.".concat(variableKey, ".").concat(innerKey, ".").concat(index));
                        });
                    }
                    else {
                        handleFile(innerVariable, "variables.".concat(variableKey, ".").concat(innerKey));
                    }
                };
                for (var innerKey in variable) {
                    _loop_2(innerKey);
                }
            }
            else {
                handleFile(variable, "variables.".concat(variableKey));
            }
        };
        for (var variableKey in data.variables) {
            _loop_1(variableKey);
        }
        if (fileIndex > 0) {
            var fd_1 = new FormData();
            fd_1.append("operations", operations);
            fd_1.append("map", JSON.stringify(map));
            files.forEach(function (file, index) {
                fd_1.append(fileKeys[index], file, file.name);
            });
            return fetch({
                url: "/graphql",
                method: "POST",
                data: fd_1,
            });
        }
        return fetch({
            url: "/graphql",
            method: "POST",
            data: data,
        });
    },
});
client.all = everything;
client.crud = getCrud;
